import { isEscape, returnFocus, trapFocus } from "./utils.js";


function closeGallery() {
    const galleries = document.querySelectorAll('.wp-block-pulp-photo-gallery')
    galleries.forEach(el => {
        el.classList.remove('show');
    })
}


const galleryTriggers = document.querySelectorAll('.gallery-trigger');
galleryTriggers.forEach(el => {
    el.addEventListener("click", e => {
        e.preventDefault();
        const gallery = document.getElementById(e.target.getAttribute('href').replace('#', ''));
        if (gallery) {
            gallery.classList.add('show');
            trapFocus(gallery);
            window.returnFocusTo = e.target;

            const close = gallery.querySelector('.close');
            close.addEventListener("click", e => {
                closeGallery();
            });

        }
    });
});

document.body.addEventListener('keyup', e => {
    if (isEscape(e)) {
        closeGallery()
        returnFocus();
    }
});
